import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import consultaCep from '../services/consultaCep'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import { colors } from '../utils/vars'
import FooterDelphus from '../components/FooterDelphus';
import { FrGroupBox } from '../components/FrGroupBox';
import { mCEP, mCNPJ, mTel, mVAL } from '../utils/masks';

const swal = withReactContent(Swal)

function NotasFiscais(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [erroCep, setErroCep] = useState([{ value: '', display: '' }])
  const [comboSede, setComboSede] = useState([{ value: '', display: '' }])
  const [comboCidade, setComboCidade] = useState([{ value: '', display: '' }])
  const [comboEstado, setComboEstado] = useState([{ value: '', display: '' }])
  const [comboNse, setComboNse] = useState([{ value: '', display: '' }])
  const [comboNsi, setComboNsi] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboSimNao, setComboSimNao] = useState([{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }])

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Paises', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Paises', 'Inclusao'))
      }

      setComboSede(await api.getComboData('sedes'))
      setComboEstado(await api.getComboData('estados'))
      setComboCidade(await api.getComboData('cidades'))
      setComboNse(await api.getComboData('nota_servico'))
      setComboNsi(await api.getComboData('nota_sub_item'))
      setComboFpg(await api.getComboData('formas_pagamento'))

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/notas_fiscais?pk_ntf=' + query.codigo).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            let auxValues = { ...r.data[0] }
            let buf = new Buffer(auxValues.servico_descricao)
            auxValues.servico_descricao = buf.toString('utf-8')
            setData(auxValues)
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  useEffect(() => {
    async function fetchCidades() {
      setComboCidade(await api.getComboData('cidades', data.fk_est || 0))

    }
    fetchCidades()
  }, [data.fk_est])

  function consistData(data) {
    let required = [
      'tomador_nome',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        auxValues.tomador_cep = auxValues.tomador_cep.replace('.', '');
        let errors = consistData(auxValues)
        if (errors.length === 0 && !erroCep) {
          if (updateType) {
            api.post('/notas_fiscais/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/notas_fiscais/add', auxValues).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          if (erroCep) {
            return swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
              html: `<p style='color: ${colors.info900}'>CEP Inválido</p>`,
              icon: 'warning',
            })
          }
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  const handleCpfCnpj = (e) => {
    console.log('lidou com cpf/cnpj')
  };

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    setErroCep(false)
    if (e.target.name == 'tomador_cep') {
      consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
        if (!r.data.erro) {
          auxValues.tomador_endereco = r.data.logradouro
          auxValues.tomador_complemento = r.data.complemento
          auxValues.tomador_bairro = r.data.bairro
          api.get('/cidades?descricao=' + r.data.localidade).then(res => {
            if (res.data.length > 0) {
              auxValues.fk_cid = res.data[0].pk_cid
            }
            setData(auxValues)
            swal.close()
          })
        } else {
          setErroCep(true)
          swal.fire({
            customClass: {
              container: 'my-swal'
            },

            title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
            html: `<p style='color: ${colors.info900}'>CEP Inválido</p>`,
            icon: 'warning',
          })
        }
      })

    }
  }


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Países</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>
          <FrSelect
            value={data.fk_sed || ''}
            style={{ width: 200 }}
            name="fk_sed"
            id="fk_sed"
            label='Emissor'
            data={comboSede}
            onChange={handleChange}
          />
          <FrTextInput
            maxLength='50'
            value={data.num_rps || ''}
            onChange={handleChange}
            name="num_rps"
            id="num_rps"
            color="#389492"
            label="Nº RPS"
            variant="outlined"
            size="small"
            required
            style={{ width: 100 }}
          />
          <FrTextInput
            maxLength='50'
            value={data.fk_lot || ''}
            onChange={handleChange}
            name="fk_lot"
            id="fk_lot"
            color="#389492"
            label="Nº Lote"
            variant="outlined"
            size="small"
            required
            style={{ width: 100 }}
          />

          <FrDatePicker
            value={(data.data_competencia || '').split('T')[0]}
            name="data_competencia"
            id="data_competencia"
            color="#49573B"
            label="Competência"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
          />
          <br />
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <FrGroupBox label="Tomador do Serviço">
              <FrTextInput
                maxLength='100'
                value={data.tomador_nome || ''}
                onChange={handleChange}
                name="tomador_nome"
                id="tomador_nome"
                color="#389492"
                label="Nome"
                variant="outlined"
                size="small"
                required
                style={{ width: 758 }}
              />
              <br />
              <FrTextInput
                maxLength='18'
                value={mCNPJ(data.tomador_cpf_cnpj) || ''}
                onChange={handleChange}
                name="tomador_cpf_cnpj"
                id="tomador_cpf_cnpj"
                color="#389492"
                label="CPF/CNPJ"
                variant="outlined"
                size="small"
                required
                onBlur={handleCpfCnpj}
                style={{ width: 200 }}
              />
              <FrTextInput
                maxLength='20'
                value={data.tomador_insc_municipal || ''}
                onChange={handleChange}
                name="tomador_insc_municipal"
                id="tomador_insc_municipal"
                color="#389492"
                label="I.M."
                variant="outlined"
                size="small"
                required
                style={{ width: 180 }}
              />
              <FrTextInput
                maxLength='20'
                value={data.tomador_insc_estadual || ''}
                onChange={handleChange}
                name="tomador_insc_estadual"
                id="tomador_insc_estadual"
                color="#389492"
                label="I.E."
                variant="outlined"
                size="small"
                required
                style={{ width: 180 }}
              />

              <FrTextInput
                maxLength='14'
                value={mTel(data.tomador_fone) || ''}
                onChange={handleChange}
                name="tomador_fone"
                id="tomador_fone"
                color="#389492"
                label="Fone"
                variant="outlined"
                size="small"
                required
                style={{ width: 180 }}
              />

              <br />
              <FrTextInput
                maxLength='100'
                value={data.tomador_email || ''}
                onChange={handleChange}
                name="tomador_email"
                id="tomador_email"
                color="#389492"
                label="E-mail"
                variant="outlined"
                size="small"
                required
                style={{ width: 758 }}
              />
              <br />
              <FrTextInput
                maxLength='10'
                value={mCEP(data.tomador_cep || '')}
                onChange={handleChange}
                name="tomador_cep"
                id="tomador_cep"
                color="#389492"
                label="CEP"
                variant="outlined"
                size="small"
                required
                onBlur={handleCep}
                style={{ width: 140 }}
              />

              <FrTextInput
                maxLength='100'
                value={data.tomador_bairro || ''}
                onChange={handleChange}
                name="tomador_bairro"
                id="tomador_bairro"
                color="#389492"
                label="Bairro"
                variant="outlined"
                size="small"
                required
                style={{ width: 200 }}
              />
              <FrSelect
                value={data.fk_est || ''}
                style={{ width: 200 }}
                name="fk_est"
                id="fk_est"
                label='UF'
                data={comboEstado}
                onChange={handleChange}
              />
              <FrSelect
                value={data.fk_cid || ''}
                style={{ width: 200 }}
                name="fk_cid"
                id="fk_cid"
                label='Cidade'
                data={comboCidade}
                onChange={handleChange}
              />

              <br />
              <FrTextInput
                maxLength='100'
                value={data.tomador_endereco || ''}
                onChange={handleChange}
                name="tomador_endereco"
                id="tomador_endereco"
                color="#389492"
                label="Endereço"
                variant="outlined"
                size="small"
                required
                style={{ width: 446 }}
              />
              <FrTextInput
                maxLength='20'
                value={data.tomador_numero || ''}
                onChange={handleChange}
                name="tomador_numero"
                id="tomador_numero"
                color="#389492"
                label="Número"
                variant="outlined"
                size="small"
                required
                style={{ width: 130 }}
              />
              <FrTextInput
                maxLength='30'
                value={data.tomador_complemento || ''}
                onChange={handleChange}
                name="tomador_complemento"
                id="tomador_complemento"
                color="#389492"
                label="Complemento"
                variant="outlined"
                size="small"
                required
                style={{ width: 170 }}
              />

              <br />


              <FrTextInput
                maxLength='100'
                value={data.conta_credito || ''}
                onChange={handleChange}
                name="conta_credito"
                id="conta_credito"
                color="#389492"
                label="C. Crédito"
                variant="outlined"
                size="small"
                required
                style={{ width: 200 }}
              />
              <FrTextInput
                maxLength='100'
                value={data.conta_debito || ''}
                onChange={handleChange}
                name="conta_debito"
                id="conta_debito"
                color="#389492"
                label="C. Débito"
                variant="outlined"
                size="small"
                required
                style={{ width: 200 }}
              />

            </FrGroupBox>

            <FrGroupBox label="Identificação do Serviço">
              <FrSelect
                value={data.fk_nse || ''}
                style={{ width: 758 }}
                name="fk_nse"
                id="fk_nse"
                label='Código de Tributação do Município'
                data={comboNse}
                onChange={handleChange}
              />
              <br />
              <FrSelect
                value={data.fk_nsi || ''}
                style={{ width: 758 }}
                name="fk_nsi"
                id="fk_nsi"
                label='Item da Lista de Serviçoes'
                data={comboNse}
                onChange={handleChange}
              />
              <br />
              <FrTextInput
                maxLength='10000'
                value={data.servico_descricao || ''}
                onChange={handleChange}
                name="servico_descricao"
                id="servico_descricao"
                color="#389492"
                label="Descriminação do Serviço Prestado"
                variant="outlined"
                size="small"
                required
                multiline
                rows='8'
                maxRows='8'
                style={{ width: 758 }}
              />
            </FrGroupBox>

          </div>

          <br />

          <FrGroupBox label="Forma de Pagamento e Valores">
            <FrSelect
              value={data.fk_fpg || ''}
              style={{ width: 358 }}
              name="fk_fpg"
              id="fk_fpg"
              label='Forma de Pagamento'
              data={comboFpg}
              onChange={handleChange}
            />
            <FrTextInput
              value={mVAL(data.valor_servicos) || ''}
              onChange={handleChange}
              name="valor_servicos"
              id="valor_servicos"
              color="#389492"
              label="Valor Total do Serviço"
              variant="outlined"
              size="small"
              required
              style={{ width: 250 }}
            />
            <br />

            <FrTextInput
              value={mVAL(data.valor_deducoes) || ''}
              onChange={handleChange}
              name="valor_deducoes"
              id="valor_deducoes"
              color="#389492"
              label="Valor Deduções"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrTextInput
              value={mVAL(data.valor_desconto_condicionado) || ''}
              onChange={handleChange}
              name="valor_desconto_condicionado"
              id="valor_desconto_condicionado"
              color="#389492"
              label="Desconto Condicionado"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrTextInput
              value={mVAL(data.valor_desconto_incondicionado) || ''}
              onChange={handleChange}
              name="valor_desconto_incondicionado"
              id="valor_desconto_incondicionado"
              color="#389492"
              label="Desconto Incondicionado"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrTextInput
              value={mVAL(data.valor_inss) || ''}
              onChange={handleChange}
              name="valor_inss"
              id="valor_inss"
              color="#389492"
              label="Valor do INSS"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <br />

            <FrTextInput
              value={mVAL(data.valor_ir) || ''}
              onChange={handleChange}
              name="valor_ir"
              id="valor_ir"
              color="#389492"
              label="Valor do IR"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrTextInput
              value={mVAL(data.valor_pis) || ''}
              onChange={handleChange}
              name="valor_pis"
              id="valor_pis"
              color="#389492"
              label="Valor do PIS"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrTextInput
              value={mVAL(data.valor_cofins) || ''}
              onChange={handleChange}
              name="valor_cofins"
              id="valor_cofins"
              color="#389492"
              label="Valor da COFINS"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrTextInput
              value={mVAL(data.valor_csll) || ''}
              onChange={handleChange}
              name="valor_csll"
              id="valor_csll"
              color="#389492"
              label="Valor da CSLL"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <br />
            <FrTextInput
              value={mVAL(data.valor_outras_retencoes) || ''}
              onChange={handleChange}
              name="valor_outras_retencoes"
              id="valor_outras_retencoes"
              color="#389492"
              label="Outras Retenções"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            <FrSelect
              value={data.valor_iss_retido || ''}
              style={{ width: 158 }}
              name="valor_iss_retido"
              id="valor_iss_retido"
              label='ISS Retido'
              data={comboSimNao}
              onChange={handleChange}
            />
            <FrSelect
              value={data.aliq || ''}
              style={{ width: 188 }}
              name="aliq"
              id="aliq"
              label='Alíquota'
              data={comboSimNao}
              disabled
              readOnly
              onChange={handleChange}
            />
          </FrGroupBox>

          <FrGroupBox label='Dados da Mensalidade/Contrato'>
            <FrTextInput
              maxLength='2'
              value={data.tipo_contrato || ''}
              onChange={handleChange}
              name="tipo_contrato"
              id="tipo_contrato"
              color="#389492"
              label="Tipo"
              variant="outlined"
              size="small"
              required
              style={{ width: 185 }}
            />
            {
              data.tipo_contrato == 'PF' ?
                <FrTextInput
                  value={(data.fk_cto) || ''}
                  onChange={handleChange}
                  name="fk_cto"
                  id="fk_cto"
                  color="#389492"
                  label="Nº Contrato"
                  variant="outlined"
                  size="small"
                  required
                  style={{ width: 185 }}
                />
                :
                <FrTextInput
                  value={(data.fk_cte) || ''}
                  onChange={handleChange}
                  name="fk_cte"
                  id="fk_cte"
                  color="#389492"
                  label="Nº Contrato"
                  variant="outlined"
                  size="small"
                  required
                  style={{ width: 185 }}
                />
            }
            <FrSelect
              value={data.ct_fk_sed || ''}
              style={{ width: 358 }}
              name="ct_fk_sed"
              id="ct_fk_sed"
              label='Unidade'
              data={comboSede}
              onChange={handleChange}
            />
            <br />
            <FrDatePicker
              value={(data.data_fim || '').split('T')[0]}
              name="data_fim"
              id="data_fim"
              color="#49573B"
              label="Vencimento"
              variant="outlined"
              size="small"
              style={{ width: 190 }}
              onChange={handleChange}
            />
            <FrTextInput
              maxLength='50'
              value={data.nsu || ''}
              onChange={handleChange}
              name="nsu"
              id="nsu"
              color="#389492"
              label="Nº RPS"
              variant="outlined"
              size="small"
              required
              style={{ width: 100 }}
            />
            <br />
            <FrTextInput
              maxLength='50'
              value={data.num_rps || ''}
              onChange={handleChange}
              name="num_rps"
              id="num_rps"
              color="#389492"
              label="Nº RPS"
              variant="outlined"
              size="small"
              required
              style={{ width: 100 }}
            />
          </FrGroupBox>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default NotasFiscais;
